<script lang="ts">
    import Modal from 'src/components/cabinet/#common/modal/Modal.svelte.ts'
    import Time from 'svelte-time'
    import {Link} from 'svelte-routing'
    import {Table} from 'sveltestrap'
    import Pagination from 'src/components/#common/pagination/Pagination.svelte'
    import {
        getAllConfirmationActions,
        deleteAction,
        addSolutionAdmin,
        getNotConfirmedActionsCount,
        addSolutionAdminForMany
    } from 'src/components/cabinet/#services/confirmationActions'
    import {getSettingOption} from 'src/components/cabinet/#services/settingsOption'
    import {doShow as showAlert} from 'src/components/#common/alert/store'
    import {myRole} from 'src/components/#common/myRole'
    import {userProfile} from 'src/services/auth'
    import {delay} from 'src/global/delay'
    import PerPage from 'src/components/#common/pagination/PerPage.svelte'
    import {copyClipboard, roundNumber, roundNumberFloor} from 'src/components/#common/helpers'
    import Accordion from 'src/components/cabinet/#common/accordion/Accordion.svelte'
    import IconifyIcon from '@iconify/svelte'
    import confirmedIcon from '@iconify/icons-fa-solid/check-circle'
    import notConfirmedIcon from '@iconify/icons-fa-solid/ban'
    import updateIcon from '@iconify/icons-fa-solid/sync'
    import mpIpAddressIcon from '@iconify/icons-fa-solid/user-friends'
    import ipAddressIcon from '@iconify/icons-fa-solid/mobile-alt'
    import withdrawIcon from '@iconify/icons-fa-solid/wallet'
    import bulkPurchasesIcon from '@iconify/icons-fa-solid/dragon'
    import achievementsIcon from '@iconify/icons-fa-solid/trophy'
    import {getNearWithdrawAccountBalance} from 'src/components/cabinet/#services/nearAdapter'
    import {getPolygonWithdrawAccountBalance} from 'src/components/cabinet/#services/evmAdapter'

    let suspicious = false
    let pending = false
    let currentPage = 0
    let perPage = 25
    let maxButtons = 5
    let startDate
    let endDate
    let emailAddress
    let supportId
    let action
    let loading = false
    let showDeleteActionModal = false
    let showConfirmModal = false
    let idForAction
    let selectedItems = []
    let selectedAmount = {
        near: { WLIS: 0, NEAR: 0, USDT: 0 },
        polygon: { WLIS: 0, USDT: 0, MATIC: 0 }
    }
    let selectedAll = false
    let maxDate = new Date()
    let dd = String(maxDate.getDate()).padStart(2, '0')
    let mm = String(maxDate.getMonth() + 1).padStart(2, '0')
    let yyyy = maxDate.getFullYear()
    maxDate = yyyy+'-'+mm+'-'+dd

    let reasonIcon = {
        'multiaccount_marketplace_ip_address': mpIpAddressIcon,
        'multiaccount_ip_address': ipAddressIcon,
        'multiaccount_withdraw': withdrawIcon,
        'multiaccount_marketplace': bulkPurchasesIcon,
        'achievements': achievementsIcon
    }

    let reasonDesc = {
        'multiaccount_marketplace_ip_address': 'Number of accounts on the marketplace from one IP',
        'multiaccount_ip_address': 'Number of registered accounts from one IP',
        'multiaccount_withdraw': 'Number of accounts that withdraw to one wallet',
        'multiaccount_marketplace': 'Number of accounts that abused the marketplace',
        'achievements': 'Completed 50 achievements within 24 hours'
    }

    function confirmationCount() {
        getSettingOption.request({ data: { clientKey: "withdrawal.confirms" } })
    }

    function updateBalanceHandler() {
        getNearWithdrawAccountBalance.reset()
        getNearWithdrawAccountBalance.send()
        getPolygonWithdrawAccountBalance.reset()
        getPolygonWithdrawAccountBalance.send()
    }

    $: pending, suspicious, filter()

    function filter() {
        getAllConfirmationActions.reset()
        getAllConfirmationActions.send({data:{
            page: currentPage + 1,
            perPage,
            userEmail: emailAddress,
            clientId: supportId,
            isUserSuspicious: suspicious ? suspicious : undefined,
            status: pending ? pending : undefined,
            tab: 'withdraw',
            startDate,
            endDate
        }})

        getNotConfirmedActionsCount.send()
        getNearWithdrawAccountBalance.send()
        getPolygonWithdrawAccountBalance.send()
        selectedAll = false
        selectedItems = []
        selectedAmount.near.WLIS = 0
        selectedAmount.near.NEAR = 0
        selectedAmount.near.USDT = 0
        selectedAmount.polygon.WLIS = 0
        selectedAmount.polygon.USDT = 0
        selectedAmount.polygon.MATIC = 0
    }

    async function addSolutionAdminHandler() {
        try {
            loading = true

            await addSolutionAdmin.request({ data: {
                id: idForAction,
                isConfirmed: action
            }})
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            await delay(500)
            loading = false
            showConfirmModal = false
            filter()
        }
    }

    async function deleteActionHandler() {
        try {
            loading = true

            await deleteAction.request({ data: {
                id: idForAction
            }})

            showAlert.set({
                status: 'success',
                text: 'Action canceled successfully'
            })
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            showDeleteActionModal = false
            filter()
        }
    }

    function toggleItem(id, params) {
        selectedAll = false
        if (selectedItems.includes(id)) {
            let index = selectedItems.indexOf(id)
            if (index !== -1) selectedItems.splice(index, 1)
            selectedItems = [...selectedItems]
            selectedAmount[params?.network || 'near'][params?.currency] -= +params?.amount
        } else {
            selectedItems = [...selectedItems, id]
            selectedAmount[params?.network || 'near'][params?.currency] += +params?.amount
        }
    }

    function toggleAll() {
        selectedAmount.near.WLIS = 0
        selectedAmount.near.NEAR = 0
        selectedAmount.near.USDT = 0
        selectedAmount.polygon.WLIS = 0
        selectedAmount.polygon.USDT = 0
        selectedAmount.polygon.MATIC = 0
        if (!selectedAll) {
            selectedItems = []
            $getAllConfirmationActions.value.data.map(elem => {
                if (elem.isSuccess === null && !elem.history?.some(e => e.userId === $userProfile?.userId)) {
                    selectedAmount[elem?.infoMethod?.params?.network || 'near'][elem?.infoMethod?.params?.currency] += +elem?.infoMethod?.params?.amount
                    selectedItems = [...selectedItems, elem.id]
                }
            })
            selectedItems = selectedItems
            if (selectedItems.length) {
                selectedAll = true
            }
        } else {
            selectedAll = false
            selectedItems = []
        }
    }

    function copy(value) {
        copyClipboard(value)
        alert('Hot wallet copied')
    }

    async function addSolutionAdminForManyHandler(action) {
        try {
            loading = true

            await addSolutionAdminForMany.request({ data: {
                ids: selectedItems,
                isConfirmed: action
            }})
        } catch (err) {
            if (err.message) {
                showAlert.set({
                    status: 'error',
                    text: err.message
                })
            } else {
                showAlert.set({
                    status: 'error',
                    text: 'An Error Occurred, Please Try Again Later'
                })
            }
        } finally {
            loading = false
            showConfirmModal = false
            filter()
        }
    }

    function reset() {
        startDate = undefined
        endDate = undefined
        emailAddress = undefined
        supportId = undefined
        currentPage = 0
        suspicious = false
        pending = false
        filter()
    }

    function checkIfEnoughBalance(params) {
        let { currency, amount, network = 'near' } = params
        if (currency === 'WLIS') currency = 'LIS'

        if (network === 'near') {
            return +amount < +$getNearWithdrawAccountBalance.value[currency]
        } else if (network === 'polygon') {
            return +amount < +$getPolygonWithdrawAccountBalance.value[currency]
        }
    }

    function checkIfEnoughBalanceAll() {
        return selectedAmount.near.WLIS > +$getNearWithdrawAccountBalance.value.LIS ||
        selectedAmount.near.NEAR > +$getNearWithdrawAccountBalance.value.NEAR ||
        selectedAmount.near.USDT > +$getNearWithdrawAccountBalance.value.USDT ||
        selectedAmount.polygon.WLIS > +$getPolygonWithdrawAccountBalance.value.LIS ||
        selectedAmount.polygon.USDT > +$getPolygonWithdrawAccountBalance.value.USDT
        selectedAmount.polygon.MATIC > +$getPolygonWithdrawAccountBalance.value.MATIC
    }

    $:currentPage,perPage,filter(),confirmationCount()
</script>

<div class="actions-list">
    <div class="buttons">
        <Link to="withdrawals" class="btn btn-primary">All</Link>
        <div class="pc-line">
            <label class="suspicious-label"><input type="checkbox" bind:checked={pending}>Pending</label>
        </div>
        <div class="pc-line">
            <label class="suspicious-label"><input type="checkbox" bind:checked={suspicious}>Suspicious</label>
        </div>
        <div class="pc-line">
            <input type="text" bind:value={supportId} class="form-control wallet-address" placeholder="Support ID">
        </div>
        <div class="pc-line">
            <input type="text" bind:value={emailAddress} class="form-control wallet-address" placeholder="Enter Email">
        </div>
        <div class="pc-line">
            <input type="date" bind:value={startDate} class="form-control" max="{maxDate}">
        </div>
        <div class="pc-line">
            <input type="date" bind:value="{endDate}" class="form-control" max="{maxDate}">
        </div>
        <div class="pc-line">
            <button class="btn btn-primary btn-filter" on:click={filter}>Filter</button>
            <button class="btn btn-secondary" on:click={reset}>Reset</button>
        </div>
    </div>
    {#if $getAllConfirmationActions.hasValue}
        <PerPage
            bind:perPage={perPage}
            disabled={$getAllConfirmationActions.loading || $getAllConfirmationActions.loading}
            totalCount={$getAllConfirmationActions.value.totalCount}
        />
    {/if}
    <Table bordered striped responsive>
        <thead>
        <tr>
            {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
                <td class="text-center col-auto">...</td>
            {/if}
            <td class="text-center">Status</td>
            <td class="text-center">Amount</td>
            <td class="text-center">User</td>
            <td class="text-center">Date</td>
            <td class="text-center">Actions</td>
        </tr>
        </thead>
        <tbody>
        {#if $getAllConfirmationActions.loading}
            {#each {length: perPage} as item}
                <tr>
                    {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
                        <td><span class="loading transaction-loading col-auto"></span></td>
                    {/if}
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                    <td><span class="loading transaction-loading"></span></td>
                </tr>
            {/each}
        {:else if $getAllConfirmationActions.error || !$getAllConfirmationActions.hasValue}
            <tr>
                <td class="text-center" colspan="{$myRole?.value?.methods.includes('addSolutionAdmin') ? '6' : '5'}">
                    {#if $getAllConfirmationActions.error}
                        {$getAllConfirmationActions.error}
                    {:else}
                        Something went wrong. Try refreshing the page.
                    {/if}
                </td>
            </tr>
        {:else}
            {#each $getAllConfirmationActions.value.data as {
                    id,userId,receiverAddress,isSuccess,infoMethod,email,history,nickname,suspicious,suspiciousReasons,createdAt
                }}
                <tr class="table-card" class:suspicious={suspicious}>
                    {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
                        <td class="text-center col-auto">
                            {#if isSuccess === null && !history?.some(e => e.userId === $userProfile?.userId)}
                                <label class="checkbox">
                                    <input type="checkbox" class="form-check-input" checked={selectedItems.includes(id)}
                                       on:change={() => toggleItem(id, infoMethod?.params)}>
                                </label>
                            {/if}
                        </td>
                    {/if}
                    <td class="text-center">
                        {#if isSuccess === true }
                            <span class="status-success">Success</span>
                        {:else if isSuccess === false}
                            <span class="status-cancelled">Cancelled</span>
                        {:else}
                            <span class="status-pending">Pending
                            ({#if history}{@html Object.keys(history).length}{:else}0{/if}/{$getSettingOption.value?.value})
                            </span>
                        {/if}
                    </td>
                    <td class="text-center">
                        {roundNumber(+infoMethod.params.amount)}
                        {!infoMethod.params.currency || infoMethod.params.currency === 'WLIS' ? 'LIS' : infoMethod.params.currency}
                    </td>
                    <td class="text-center">
                        <a href="/profile/{infoMethod.params.userId}" target="_blank" rel="noreferrer">{email}</a>
                        {#if suspiciousReasons}
                            {#each Object.entries(suspiciousReasons) as [reason, value]}
                                <div class="reason-icon" title="{reasonDesc[reason]}{reason !== 'achievements' ? ': '+value : ''}">
                                    <IconifyIcon icon={reasonIcon[reason]}/>
                                </div>
                            {/each}
                        {/if}
                        {#if infoMethod?.params?.network === 'polygon'}
                            <a href="https://polygonscan.com/address/{receiverAddress}" class="wallet" target="_blank" rel="noreferrer">
                                {receiverAddress.slice(0,5)}...{receiverAddress.slice(-5)} ({infoMethod?.params?.network || 'near'})
                            </a>
                        {:else}
                            {#if receiverAddress && receiverAddress.length >= 20}
                                <a href="{infoMethod.params.currency === 'WLIS' ? 'https://nearblocks.io/token/token.v1.realisnetwork.near?a=' : 'https://nearblocks.io/address/'}{receiverAddress}" class="wallet" target="_blank" rel="noreferrer">
                                    {receiverAddress.slice(0,5)}...{receiverAddress.slice(-5)} ({infoMethod?.params?.network || 'near'})
                                </a>
                            {:else if receiverAddress}
                                <a href="{infoMethod.params.currency === 'WLIS' ? 'https://nearblocks.io/token/token.v1.realisnetwork.near?a=' : 'https://nearblocks.io/address/'}{receiverAddress}" class="wallet" target="_blank" rel="noreferrer">
                                    {receiverAddress} ({infoMethod?.params?.network || 'near'})
                                </a>
                            {/if}
                        {/if}
                    </td>
                    <td class="text-center nobr action-date"><Time relative timestamp={createdAt}/></td>
                    <td class="text-center">
                        {#if isSuccess == null && $userProfile?.userId === userId}
                            <button class="btn btn-primary" on:click={() => {idForAction = id; showDeleteActionModal = true }}>Cancel</button>
                        {:else if isSuccess == null && $myRole?.value?.methods.includes('addSolutionAdmin') && !history?.some(e => e.userId === $userProfile?.userId)}
                            {#if $getNearWithdrawAccountBalance.hasValue && $getPolygonWithdrawAccountBalance.hasValue && checkIfEnoughBalance(infoMethod?.params)}
                                <button class="btn btn-success" on:click={()=>{idForAction = id; action = true; showConfirmModal = true}}>Yes</button>
                            {:else}
                                <button class="btn btn-success" disabled>Yes</button>
                            {/if}
                            <button class="btn btn-danger" on:click={()=>{idForAction = id; action = false; showConfirmModal = true}}>No</button>
                        {/if}
                        {#if history.length}
                            <Accordion button={'Details'}>
                                {#each history as {userId, email, isConfirmed}}
                                    {#if email}
                                        <p class="admin-item">
                                            {#if isConfirmed}
                                                <span class="admin-confirmed">
                                                    <IconifyIcon icon={confirmedIcon}></IconifyIcon>
                                                </span>
                                            {:else}
                                                <span class="admin-not-confirmed">
                                                    <IconifyIcon icon={notConfirmedIcon}></IconifyIcon>
                                                </span>
                                            {/if}
                                            <a href="/profile/{userId}" target="_blank" rel="noreferrer">{email}</a>
                                        </p>
                                    {/if}
                                {/each}
                            </Accordion>
                        {/if}
                    </td>
                </tr>
            {/each}
        {/if}
        </tbody>
        <Modal bind:visible={showConfirmModal}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Action confirmation</div>
                <div class="modal-custom__text">Are you sure you want to confirm <strong>[{#if action}Yes{:else}No{/if}]</strong> action?</div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { showConfirmModal = false }}>Close</button>
                    <button class="btn btn-primary" class:loading={loading} on:click={addSolutionAdminHandler} disabled={loading}>Confirm</button>
                </div>
            </svelte:fragment>
        </Modal>
        <Modal bind:visible={showDeleteActionModal}>
            <svelte:fragment slot="content">
                <div class="modal-custom__title">Cancel action</div>
                <div class="modal-custom__text">Are you sure you want to undo your action?</div>
                <div class="modal-custom__footer">
                    <button class="btn btn-cancel" on:click={() => { showDeleteActionModal = false }}>Close</button>
                    <button class="btn btn-primary" class:loading={loading} on:click={deleteActionHandler} disabled={loading}>Confirm</button>
                </div>
            </svelte:fragment>
        </Modal>
    </Table>
    {#if $myRole?.value?.methods.includes('addSolutionAdmin')}
        <div class="d-flex mb-3 fixed-panel">
            <button class="btn btn-primary mr-2" class:loading={loading} on:click={toggleAll}
                disabled={loading}>{#if !selectedAll}Select all{:else}Deselect all{/if}</button>
            <button class="btn btn-success mr-2" class:loading={loading} on:click={() => addSolutionAdminForManyHandler(true)}
                disabled={loading || !selectedItems.length || !$getAllConfirmationActions.hasValue ||
                !$getNearWithdrawAccountBalance.hasValue || !$getPolygonWithdrawAccountBalance.hasValue || checkIfEnoughBalanceAll()}>
                Approve
            </button>
            <button class="btn btn-danger" class:loading={loading} on:click={() => addSolutionAdminForManyHandler(false)}
                disabled={loading || !selectedItems.length || !$getAllConfirmationActions.hasValue}>Deny</button>
            <div class="balances">
                {#if !$getNearWithdrawAccountBalance.hasValue || $getNearWithdrawAccountBalance.loading || !$getPolygonWithdrawAccountBalance.hasValue || $getPolygonWithdrawAccountBalance.loading}
                    <div on:click={() => copy('b472b6027d8f6525ba223f8a225f777f515c3cb69d9cd76c5d697d7edc57dd01')} title="Copy">
                        <div class="mini-label">Near</div>... LIS
                    </div>
                    <div on:click={() => copy('b472b6027d8f6525ba223f8a225f777f515c3cb69d9cd76c5d697d7edc57dd01')} title="Copy">
                        <div class="mini-label">Near</div>... NEAR
                    </div>
                    <div on:click={() => copy('b472b6027d8f6525ba223f8a225f777f515c3cb69d9cd76c5d697d7edc57dd01')} title="Copy">
                        <div class="mini-label">Near</div>... USDT
                    </div>
                    <div on:click={() => copy('0x73044f0d1a75deb9f67a188dff792ef0e6acb34e')} title="Copy">
                        <div class="mini-label">Polygon</div>... LIS
                    </div>
                    <div on:click={() => copy('0x73044f0d1a75deb9f67a188dff792ef0e6acb34e')} title="Copy">
                        <div class="mini-label">Polygon</div>... USDT
                    </div>
                    <div on:click={() => copy('0x73044f0d1a75deb9f67a188dff792ef0e6acb34e')} title="Copy">
                        <div class="mini-label">Polygon</div>... MATIC
                    </div>
                    <div class="update-btn" style="opacity: 0.8">
                        <IconifyIcon icon={updateIcon}/>
                    </div>
                {:else if $getNearWithdrawAccountBalance.hasValue && $getPolygonWithdrawAccountBalance.hasValue}
                    {#if $getNearWithdrawAccountBalance.value?.LIS}
                        <div class:account-balance-limit={selectedAmount.near.WLIS > $getNearWithdrawAccountBalance.value.LIS}
                            on:click={() => copy('b472b6027d8f6525ba223f8a225f777f515c3cb69d9cd76c5d697d7edc57dd01')} title="Copy">
                            <div class="mini-label">Near</div>
                            {#if selectedAmount.near.WLIS > 0}{roundNumberFloor(selectedAmount.near.WLIS, 0)} / {/if}
                            {roundNumberFloor($getNearWithdrawAccountBalance.value.LIS, 0)} LIS
                        </div>
                    {/if}
                    {#if $getNearWithdrawAccountBalance.value?.NEAR}
                        <div class:account-balance-limit={selectedAmount.near.NEAR > $getNearWithdrawAccountBalance.value.NEAR}
                            on:click={() => copy('b472b6027d8f6525ba223f8a225f777f515c3cb69d9cd76c5d697d7edc57dd01')} title="Copy">
                            <div class="mini-label">Near</div>
                            {#if selectedAmount.near.NEAR > 0}{roundNumberFloor(selectedAmount.near.NEAR, 2)} / {/if}
                            {roundNumberFloor($getNearWithdrawAccountBalance.value.NEAR, 2)} NEAR
                        </div>
                    {/if}
                    {#if $getNearWithdrawAccountBalance.value?.USDT}
                        <div class:account-balance-limit={selectedAmount.near.USDT > $getNearWithdrawAccountBalance.value.USDT}
                            on:click={() => copy('b472b6027d8f6525ba223f8a225f777f515c3cb69d9cd76c5d697d7edc57dd01')} title="Copy">
                            <div class="mini-label">Near</div>
                            {#if selectedAmount.near.USDT > 0}{roundNumberFloor(selectedAmount.near.USDT, 2)} / {/if}
                            {roundNumberFloor($getNearWithdrawAccountBalance.value.USDT, 2)} USDT
                        </div>
                    {/if}
                    {#if $getPolygonWithdrawAccountBalance.value?.LIS}
                        <div class:account-balance-limit={selectedAmount.polygon.WLIS > $getPolygonWithdrawAccountBalance.value.LIS}
                            on:click={() => copy('0x73044f0d1a75deb9f67a188dff792ef0e6acb34e')} title="Copy">
                            <div class="mini-label">Polygon</div>
                            {#if selectedAmount.polygon.WLIS > 0}{roundNumberFloor(selectedAmount.polygon.WLIS, 0)} / {/if}
                            {roundNumberFloor($getPolygonWithdrawAccountBalance.value.LIS, 0)} LIS
                        </div>
                    {/if}
                    {#if $getPolygonWithdrawAccountBalance.value?.USDT}
                        <div class:account-balance-limit={selectedAmount.polygon.USDT > $getPolygonWithdrawAccountBalance.value.USDT}
                            on:click={() => copy('0x73044f0d1a75deb9f67a188dff792ef0e6acb34e')} title="Copy">
                            <div class="mini-label">Polygon</div>
                            {#if selectedAmount.polygon.USDT > 0}{roundNumberFloor(selectedAmount.polygon.USDT, 0)} / {/if}
                            {roundNumberFloor($getPolygonWithdrawAccountBalance.value.USDT, 0)} USDT
                        </div>
                    {/if}
                    {#if $getPolygonWithdrawAccountBalance.value?.MATIC}
                        <div class:account-balance-limit={selectedAmount.polygon.MATIC > $getPolygonWithdrawAccountBalance.value.MATIC}
                            on:click={() => copy('0x73044f0d1a75deb9f67a188dff792ef0e6acb34e')} title="Copy">
                            <div class="mini-label">Polygon</div>
                            {#if selectedAmount.polygon.MATIC > 0}{roundNumberFloor(selectedAmount.polygon.MATIC, 0)} / {/if}
                            {roundNumberFloor($getPolygonWithdrawAccountBalance.value.MATIC, 0)} MATIC
                        </div>
                    {/if}
                    <div class="update-btn" on:click={() => updateBalanceHandler()}>
                        <IconifyIcon icon={updateIcon}/>
                    </div>
                {/if}
            </div>
        </div>
    {/if}
    {#if $getAllConfirmationActions.hasValue}
        <Pagination
            bind:currentPage={currentPage}
            totalCount={$getAllConfirmationActions.value.totalCount}
            {perPage}
            {maxButtons}
            disabled={$getAllConfirmationActions.loading || $getAllConfirmationActions.loading}
        />
    {/if}
</div>

<style>
    .reason-icon {
        display: inline-block;
        color: #f44336;
        padding: 0 4px;
        cursor: pointer;
    }

    .mini-label {
        position: absolute;
        background: #6c757d;
        color: white;
        font-size: 10px;
        left: 5px;
        top: 4px;
        padding: 2px 3px;
        border-radius: 3px;
        line-height: 1;
    }

    .account-balance-limit .mini-label {
        background: #b53026;
    }

    .balances {
        display: flex;
    }

    .balances > div {
        margin-left: 10px;
        background: #8391a240;
        border-radius: 5px;
        padding: 20px 14px 4px 10px;
        font-size: 15px;
        line-height: normal;
        color: #313a46;
        position: relative;
        transition: .25s;
        cursor: pointer;
    }

    .balances > .update-btn {
        padding-top: 10px;
        cursor: pointer;
    }

    .balances > div:hover {
        background: #cdd1d9;
    }

    .actions-list {
        padding-bottom: 20px;
    }

    .wallet-address {
        display: inline-block;
        width: auto;
    }

    .suspicious-label {
        padding: 8px;
        cursor: pointer;
    }

    .suspicious-label input {
        width: 16px;
        height: 16px;
        vertical-align: top;
        margin: 2px 5px 0 0;
        cursor: pointer;
    }

    .checkbox input[type="checkbox"] {
        width: 1em;
        height: 1em;
        margin-top: 3px;
        vertical-align: top;
        margin-right: 10px;
        background: none;
        border-radius: 2px;
        border: 1px solid #A0AEC0;
        -webkit-appearance: none;
        -moz-appearance: none;
        appearance: none;
        -webkit-print-color-adjust: exact;
        color-adjust: exact;
    }

    .checkbox input[type="checkbox"]:checked {
        background-color: #FF5D1C;
        border-color: #FF5D1C;
        background-image: url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 20 20'%3e%3cpath fill='none' stroke='%23fff' stroke-linecap='round' stroke-linejoin='round' stroke-width='3' d='M6 10l3 3l6-6'/%3e%3c/svg%3e");
    }

    .buttons {
        margin-bottom: 15px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .btn-primary.btn-filter {
        padding: 8px 20px;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .pc-line {
        display: inline-block;
        margin-bottom: 10px;
        vertical-align: top;
    }

    .admin-confirmed {
        color: #4caf50;
        padding-right: 2px;
    }

    .admin-not-confirmed {
        color: #f44336;
        padding-right: 2px;
    }

    .admin-item {
        margin-bottom: 5px;
    }

    .transaction-loading {
        height: 24px;
        width: 100%;
        display: block;
    }

    .mr-2 {
        margin-right: 10px;
    }

    .buttons .btn {
        margin-left: 5px;
    }

    .btn.btn-secondary {
        padding: 10px 20px;
        font-size: 14px;
        line-height: normal;
        border: 0;
        box-shadow: none;
    }

    td .btn {
        padding: 6px 20px !important;
        margin: -6px 0 !important;
    }

    td {
        vertical-align: middle;
        min-width: 150px;
    }

    .btn.active {
        background: #FF5D1C;
    }

    .status-pending {
        color: #ff9800;
    }

    .status-cancelled {
        color: #f44336;
    }

    .status-success {
        color: #4caf50;
    }

    input[type="date"] {
        width: auto;
        display: inline-block;
        vertical-align: top;
    }

    .nobr {
        white-space: nowrap;
    }

    .checkbox {
        padding: 0 20px;
        font-size: 20px;
    }

    .suspicious .checkbox {
        padding: 20px 20px 0;
    }

    .checkbox input {
        font-size: 20px;
    }

    .col-auto {
        width: 80px;
        min-width: 70px;
        margin: 0 auto;
    }

    .table-card.suspicious {
        background: #ffe2e0;
        position: relative;
    }

    .table-card.suspicious td:first-child:before {
        content: "Suspicious";
        position: absolute;
        font-size: 11px;
        background: #f44336;
        border-radius: 3px;
        padding: 1px 5px;
        color: white;
        top: 5px;
        left: 5px;
    }

    .wallet {
        display: table;
        margin: 0 auto;
        color: #4482a1;
    }

    .fixed-panel {
        position: fixed;
        background: white;
        padding: 20px 0 20px 300px;
        width: 100%;
        bottom: 0;
        margin: 0 !important;
        left: 0;
        z-index: 4;
        box-shadow: 0 -2px 5px rgba(0, 0, 0, 0.1);
    }

    .balances > .account-balance-limit {
        background: #e1574d;
        color: white;
    }

    @media(max-width: 991px) {
        thead {
            display: none;
        }

        td {
            display: block;
        }

        td:empty {
            display: none !important;
        }

        .table-card {
            text-align: center;
            margin-bottom: 12px;
            display: block;
        }

        .table-card td:last-child {
            padding-bottom: 20px;
        }

        .user-link {
            padding: 0;
        }

        .action-date {
            font-size: 14px;
            color: #787878;
        }

        .col-auto {
            width: 100%;
            min-width: 100%;
            margin: 0 auto;
            position: relative;
        }

        .checkbox {
            padding: 12px;
            font-size: 18px;
            position: absolute;
            left: 0;
            top: 15px;
        }

        .fixed-panel {
            padding: 12px 0 12px 20px;
        }
    }
</style>
